var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 96,
    viewBox: "0 0 124 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_6652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.523 19.6331H37.6367C36.9014 19.6331 36.3053 20.2291 36.3053 20.9644V51.9143C36.3053 52.6496 36.9014 53.2457 37.6367 53.2457H121.523C122.258 53.2457 122.854 52.6496 122.854 51.9143V20.9644C122.854 20.2291 122.258 19.6331 121.523 19.6331Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4444 46.092C58.7779 46.092 63.1016 41.7683 63.1016 36.4348C63.1016 31.1013 58.7779 26.7776 53.4444 26.7776C48.1109 26.7776 43.7872 31.1013 43.7872 36.4348C43.7872 41.7683 48.1109 46.092 53.4444 46.092Z",
    fill: "#0C57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.397 28.1089H73.2276C72.7875 28.1089 72.4307 28.4657 72.4307 28.9058V32.6281C72.4307 33.0682 72.7875 33.425 73.2276 33.425H114.397C114.837 33.425 115.194 33.0682 115.194 32.6281V28.9058C115.194 28.4657 114.837 28.1089 114.397 28.1089Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.55,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5953 39.4539H73.2276C72.7875 39.4539 72.4307 39.8107 72.4307 40.2508V43.973C72.4307 44.4132 72.7875 44.77 73.2276 44.77H94.5953C95.0355 44.77 95.3923 44.4132 95.3923 43.973V40.2508C95.3923 39.8107 95.0355 39.4539 94.5953 39.4539Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.55,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3633 62.106H2.47695C1.74165 62.106 1.14557 62.702 1.14557 63.4373V94.3872C1.14557 95.1225 1.74165 95.7186 2.47695 95.7186H86.3633C87.0986 95.7186 87.6946 95.1225 87.6946 94.3872V63.4373C87.6946 62.702 87.0986 62.106 86.3633 62.106Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2848 88.5649C23.6183 88.5649 27.9419 84.2412 27.9419 78.9077C27.9419 73.5742 23.6183 69.2505 18.2848 69.2505C12.9512 69.2505 8.62756 73.5742 8.62756 78.9077C8.62756 84.2412 12.9512 88.5649 18.2848 88.5649Z",
    fill: "#0C57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2376 70.5725H38.0679C37.6278 70.5725 37.271 70.9293 37.271 71.3695V75.0917C37.271 75.5318 37.6278 75.8887 38.0679 75.8887H79.2376C79.6777 75.8887 80.0345 75.5318 80.0345 75.0917V71.3695C80.0345 70.9293 79.6777 70.5725 79.2376 70.5725Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.55,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4357 81.9268H38.0679C37.6278 81.9268 37.271 82.2836 37.271 82.7237V86.4459C37.271 86.8861 37.6278 87.2429 38.0679 87.2429H59.4357C59.8758 87.2429 60.2326 86.8861 60.2326 86.4459V82.7237C60.2326 82.2836 59.8758 81.9268 59.4357 81.9268Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.55,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.859 20.4676H1.68C1.38934 20.4676 1.14557 20.2332 1.14557 19.9332V10.1729C1.14557 4.31291 4.35213 0.918831 10.7746 -9.22289e-06C11.0934 -0.0468888 11.3841 0.206261 11.3841 0.534418V4.57544C11.3841 4.85672 11.159 5.07236 10.8871 5.10049C8.1025 5.34426 6.56485 6.84441 6.28357 9.59155C6.25544 9.90096 6.50859 10.1635 6.818 10.1635H10.859C11.1497 10.1635 11.3934 10.3979 11.3934 10.6979V19.9238C11.3934 20.2145 11.159 20.4582 10.859 20.4582V20.4676ZM26.2543 20.4676H17.0753C16.7846 20.4676 16.5408 20.2332 16.5408 19.9332V10.1729C16.5408 4.31291 19.7474 0.918831 26.1699 -9.22289e-06C26.4887 -0.0468888 26.7793 0.206261 26.7793 0.534418V4.57544C26.7793 4.85672 26.5543 5.07236 26.2824 5.10049C23.4978 5.34426 21.9601 6.84441 21.6788 9.59155C21.6507 9.90096 21.9038 10.1635 22.2133 10.1635H26.2543C26.5449 10.1635 26.7887 10.3979 26.7887 10.6979V19.9238C26.7887 20.2145 26.5543 20.4582 26.2543 20.4582V20.4676Z",
    fill: "#C1E8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_6652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122.271,
    height: 96,
    fill: "white",
    transform: "translate(0.864319)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.ef82eba534bfc5c148bfef6deff93b33.svg";
export { ForwardRef as ReactComponent };